import { render, staticRenderFns } from "./CommentItem.vue?vue&type=template&id=3ca91fe4&"
import script from "./CommentItem.vue?vue&type=script&lang=ts&"
export * from "./CommentItem.vue?vue&type=script&lang=ts&"
import style0 from "./CommentItem.vue?vue&type=style&index=0&lang=stylus&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports